import { isFeatureEnabled } from 'owa-feature-flags';
import { getDefaultEventDuration } from 'owa-session-store';
import {
    getDefaultShouldEventsEndEarly,
    getDefaultEndShortEventsBy,
    getDefaultEndLongEventsBy,
} from 'owa-calendar-cloud-settings';

/**
 * Gets the event duration based on the default value and the 'End events early' setting
 */
export default function getEventDuration(): number {
    let defaultDuration: number = getDefaultEventDuration();

    if (isFeatureEnabled('cal-mf-shouldEventsEndEarlySetting')) {
        const shouldEventsEndEarly = getDefaultShouldEventsEndEarly();
        let endEventsBy = 0;

        if (shouldEventsEndEarly) {
            if (defaultDuration < 60) {
                endEventsBy = getDefaultEndShortEventsBy();
            } else {
                endEventsBy = getDefaultEndLongEventsBy();
            }
        }
        defaultDuration = defaultDuration - endEventsBy;
    }

    return defaultDuration;
}
